// Provide app configuration object set in "options" cookie by server
angular.module('config').factory('tgConfig', function configFactory($window) {
	// Example of configuration object provided by server and default configuration options:
	var currentConfig, currentUser

	function unescapeHtmlNumericCodes(str) {
		return str.replace(/&#(\d+);/g, function (m, n) {
			return String.fromCharCode(n)
		})
	}

	if ($window.tagmeConfig) {
		currentConfig = {}
		angular.extend(currentConfig, JSON.parse(unescapeHtmlNumericCodes($window.tagmeConfig)))
	}

	if ($window.apitoken) {
		currentConfig = currentConfig || {}
		angular.extend(currentConfig, JSON.parse(unescapeHtmlNumericCodes({ apitoken: $window.apitoken })))
	}

	if ($window.authtoken) {
		currentConfig = currentConfig || {}
		angular.extend(currentConfig, JSON.parse(unescapeHtmlNumericCodes({ authtoken: $window.authtoken })))
	}

	if ($window.tagmeUser) {
		currentUser = {}
		angular.extend(currentUser, JSON.parse(unescapeHtmlNumericCodes($window.tagmeUser)))
	}

	if (currentConfig) {
		currentConfig.hasAuthenticatedUser = function () {
			return !!currentUser && !_.isEmpty(currentUser)
		}
		currentConfig.getAuthenticatedUser = function () {
			return currentUser
		}
		return currentConfig
	} else {
		return false
	}
})
